import React from 'react';
import { SearchBoxAutocompleteViewProps } from '@odin-labs/components';
import { SearchIcon } from 'components/icons';
import { SearchWorkerResult } from './types';
import { classes } from './SearchBoxAutocompleteList.style';
import { SearchWorkerInfo } from './searchWorkerInfo/SearchWorkerInfo';

export function SearchBoxAutocompleteList(
  props: SearchBoxAutocompleteViewProps,
): React.ReactElement {
  const { autocompletedResults, getItemProps, inputValue } = props;

  return (
    <>
      <div className={classes.autoCompleteListContainer}>
        <ul className={classes.autoCompleteList}>
          {autocompletedResults.map(
            (autocompletedResult: SearchWorkerResult, i) => {
              const itemProps = getItemProps({
                key: autocompletedResult.id,
                item: autocompletedResult,
                index: i,
              });
              return (
                <li {...itemProps} className={classes.autoCompleteListItem}>
                  <SearchWorkerInfo searchWorkerResult={autocompletedResult} />
                </li>
              );
            },
          )}
        </ul>
      </div>
      <div className={classes.seeAllResultsContainer}>
        <button type="submit" className={classes.seeAllResultsButton}>
          <SearchIcon
            className="odin-font-normal odin-mr-3"
            aria-hidden="true"
          />
          See all results for “{inputValue}”
        </button>
      </div>
    </>
  );
}
